// extracted by mini-css-extract-plugin
export default {"patternCard":"AssociationCard_patternCard__1kAX1","cardBackground":"AssociationCard_cardBackground__lfLcU","cardText":"AssociationCard_cardText__se9JZ"};